import React from 'react';
import { ClickAnchor, ClickAnchorProps, ClickMenuContainer } from './ClickMenu';

interface FileOptionsMenuProps extends Pick<ClickAnchorProps, 'offset' | 'placement' | 'inPortal'> {
  children: React.ReactNode;
  menuItems: React.ReactNode | React.ReactNode[];
}

export function FileOptionsMenu({ children, menuItems, ...clickAnchorPropOverrides }: FileOptionsMenuProps) {
  return (
    <ClickAnchor
      inPortal={false}
      placement="bottom-start"
      popperJSPreventOverflowOptions={{ padding: 24 }}
      floatingElement={<ClickMenuContainer className="mr-[-8px] !w-[192px]">{menuItems}</ClickMenuContainer>}
      {...clickAnchorPropOverrides}
    >
      {children}
    </ClickAnchor>
  );
}
